import { Navigate } from 'react-router-dom';
import { ReactSession } from '../utils/ReactSession.jsx';
import {AES, enc} from "crypto-js";
import { useParams } from "react-router";
import { usePortalVersion } from '../contexts/PortalVersionContext.jsx';
import Areas from "./Areas.jsx";
import Residents from "./Residents.jsx";
import ResidentsPage from "../pages/community/residents/ResidentsPage.jsx";
import AreasPage from "../pages/community/areas/AreasPage.jsx";
import AreaProfilePage from "../pages/community/areas/area-profile/AreaProfilePage.jsx";
import Devices from "./Devices.jsx";
import DevicesPage from "../pages/devices/DevicesPage.jsx";
import AreaGroups from "./AreaGroups.jsx";
import SystemDevices from "./SystemDevices.jsx";
import ServerDevices from "./ServerDevices.jsx";
import ServerProfile from "./profile-templates/Server.jsx";
import ServerProfilePage from "../pages/servers/profile/ServerProfilePage.jsx";
import InovonicsDevice from "./profile-templates/InovonicsDevice.jsx";
import PalcareDevice from "./profile-templates/PalcareDevice.jsx";
import DeviceProfilePage from "../pages/devices/device-profile/DeviceProfilePage.jsx";
import AreaProfile from "./profile-templates/Area.jsx";
import ResidentProfile from "./profile-templates/Resident.jsx";
import ResidentProfilePage from "../pages/community/residents/resident-profile/ResidentProfilePage.jsx";
import {iAmHigherAuthority} from "../libs.jsx";
import ResidentGroups from "./ResidentGroups.jsx";
import SessionReload from "./component-assets/SessionReload.jsx";
import WanderDevices from "./WanderDevices.jsx";

const Community = (props) => {
    let pageContent, dData, paramVars, bData;
    paramVars = useParams();
    const { portalVersion } = usePortalVersion();
    const isV2 = portalVersion === 'v2';

    if (ReactSession.get("PAL") != null){
        bData = AES.decrypt(ReactSession.get("PAL"), import.meta.env.VITE_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }
    if (paramVars.dType === "areas"){
        if (paramVars?.eType === "groups"){
            pageContent = isV2 ? <AreasPage initialTab="areagroups" /> : <AreaGroups />;
        }else if (paramVars?.eType === "buildings"){
            pageContent = isV2 ? <AreasPage initialTab="buildings" /> : <Areas />;
        }else if (paramVars?.eType && !isNaN(paramVars.eType) && iAmHigherAuthority(10, dData?.role_weight)){
            // Area profile: /community/areas/:areaId
            pageContent = isV2
                ? <AreaProfilePage id={paramVars.eType} />
                : <AreaProfile id={paramVars.eType} />;
        }else{
            pageContent = isV2 ? <AreasPage /> : <Areas />;
        }
    }else if (paramVars.dType === "residents"){
        if (paramVars?.eType === "groups"){
            // V2: render groups tab inside ResidentsPage; V1: standalone ResidentGroups
            pageContent = isV2 ? <ResidentsPage initialTab="groups" /> : <ResidentGroups />;
        }else if (paramVars?.eType && !isNaN(paramVars.eType) && iAmHigherAuthority(10, dData?.role_weight)){
            // Resident profile: /community/residents/:residentId
            pageContent = isV2
                ? <ResidentProfilePage id={paramVars.eType} />
                : <ResidentProfile id={paramVars.eType} />;
        }else{
            // V2: new residents page; V1: old residents component
            pageContent = isV2 ? <ResidentsPage /> : <Residents />;
        }
    }else if (paramVars.dType === "devices"){
        if (paramVars?.eType && paramVars?.kType) {
            // Device profile: /community/devices/:mfgId/:deviceId
            pageContent = isV2
                ? <DeviceProfilePage id={paramVars.kType} mfgId={paramVars.eType} />
                : (paramVars.eType === "4"
                    ? <PalcareDevice id={paramVars.kType} />
                    : <InovonicsDevice id={paramVars.kType} />);
        } else if (paramVars?.eType) {
            // Legacy: /community/devices/:deviceId (backwards compat, assume Inovonics)
            pageContent = isV2
                ? <DeviceProfilePage id={paramVars.eType} mfgId="1" />
                : <InovonicsDevice id={paramVars.eType} />;
        } else {
            pageContent = isV2 ? <DevicesPage /> : <Devices />;
        }
    }else if (paramVars.dType === "wander_devices") {
        pageContent = isV2 ? <DevicesPage initialTab="wandering" /> : <WanderDevices />;
    }else if (paramVars.dType === "system_devices" && iAmHigherAuthority(99, dData?.role_weight)) {
        pageContent = isV2 ? <DevicesPage initialTab="system" /> : <SystemDevices />;
    }else if (paramVars.dType === "server_devices" && iAmHigherAuthority(99, dData?.role_weight)) {
        if (paramVars?.eType) {
            // Server profile drill-down
            pageContent = isV2 ? <ServerProfilePage id={paramVars.eType} /> : <ServerProfile id={paramVars.eType} />;
        } else {
            pageContent = isV2 ? <DevicesPage initialTab="servers" /> : <ServerDevices />;
        }
    }else{
        pageContent = (
            <div>
                404 Page not found
            </div>
        );
    }

    return (iAmHigherAuthority(10, dData?.role_weight)) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {pageContent}
        </>
    ) : <Navigate to={"/"}/>;
};

export default Community;